














































































































import authModule from '@/store/auth'
import userModule from '@/store/user'
import { Component, Vue } from 'vue-property-decorator'
import { TextFieldRules } from '@/utils/enums'
import FDialog from '../../common/FDialog.vue'

@Component({
  name: 'PasswordReset'
})
class PasswordReset extends Vue {
  private email = ''
  private newPassword = ''
  private newPasswordRepeat = ''

  private showPasswordReset = false
  private showPasswordConfirm = false

  private rules = TextFieldRules

  private get isLoggedIn(): boolean {
    return authModule.isLoggedIn
  }

  private get isValidForgotPasswordForm(): boolean {
    return this.isLoggedIn || this.email.trim().length > 0
  }

  private get isValidNewPasswordForm(): boolean {
    return (
      this.newPassword.trim().length > 0 &&
      this.newPassword.trim() === this.newPasswordRepeat.trim()
    )
  }

  private async resetPassword() {
    const emailAddress = this.isLoggedIn ? authModule.user!.email : this.email
    await userModule.resetPassword(emailAddress)
    this.toggleDialog()
    this.$router.push({ name: 'Login' })
  }

  private async setNewPassword() {
    const payload = {
      newPassword: this.newPassword,
      token: this.$route.params.token
    }

    await userModule.setNewPassword(payload)
    this.toggleDialog()
    this.$router.push({ name: 'Login' })
  }

  public toggleDialog() {
    if (this.$route.name === 'NewPassword') {
      ;(this.$refs.passwordConfirmDialog as FDialog).toggleDialog()
    } else {
      ;(this.$refs.passwordResetDialog as FDialog).toggleDialog()
    }
  }
}
export default PasswordReset
